import React from 'react'
import { faCommentDots } from '@fortawesome/pro-solid-svg-icons'
import Box from '@mui/material/Box'
import CardChart from '../Components/CardChart'
import Typography from '@mui/material/Typography'
import { Table, TableBody, TableRow, TableCell, Skeleton } from '@mui/material'
import FormatDate from '../../../../../date/FormatDate'
import ReadOnlyTextEditor from '../../../../../TextEditor/ReadOnlyTextEditor'

const RecentFeedback = ({ data, isLoading }) => {
  return (
    <CardChart icon={faCommentDots} title='Recent Feedback' bgColor='#fdfafa'>
      <Table>
        <TableBody>
          {isLoading ? (
            Array.from({ length: 5 }).map((_, i) => (
              <TableRow key={i}>
                <TableCell width={'220px'}>
                  <Typography color='textSecondary' className='capitalize'>
                    <Skeleton width={100} height={20} />
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant='body2' color='textPrimary'>
                    <Skeleton width={100} height={20} />
                  </Typography>
                </TableCell>
              </TableRow>
            ))
          ) : data?.length === 0 ? (
            <TableRow>
              <TableCell colSpan={2}>
                <Typography variant='body2' color='textSecondary'>
                  No recent feedback
                </Typography>
              </TableCell>
            </TableRow>
          ) : (
            data?.map((feedback, index) => (
              <TableRow key={index}>
                <TableCell>
                  <Typography className=' capitalize'>
                    {feedback?.action} {feedback?.module === 'note' ? 'note' : ''}
                  </Typography>
                  <Typography color='textSecondary' className='text-xs'>
                    by {feedback?.user?.fullName}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color='textSecondary'>
                    <FormatDate date={feedback?.createdAt} />
                  </Typography>
                </TableCell>
                <TableCell align='left'>
                  {feedback?.class && (
                    <Box className='flex items-center justify-start gap-1'>
                      <Typography variant='body2' color='primary' className='uppercase text-xs font-bold'>
                        class
                      </Typography>
                      <Typography variant='body2' color='textPrimary' className=' '>
                        {feedback?.class || 'N/A'}
                      </Typography>
                    </Box>
                  )}
                  {feedback?.subject && (
                    <Box className='flex items-center justify-start gap-1'>
                      <Typography variant='body2' color='primary' className='uppercase text-xs font-bold'>
                        subject
                      </Typography>
                      <Typography variant='body2' color='textPrimary' className=' '>
                        {feedback?.subject || 'N/A'}
                      </Typography>
                    </Box>
                  )}
                  {feedback?.ul && (
                    <Box className='flex items-center justify-start gap-1'>
                      <Typography variant='body2' color='primary' className='uppercase text-xs font-bold'>
                        unit of learning
                      </Typography>
                      <Typography variant='body2' color='textPrimary' className=' '>
                        {feedback?.ul || 'N/A'}
                      </Typography>
                    </Box>
                  )}
                  {feedback?.lc && (
                    <Box className='flex items-center justify-start gap-1'>
                      <Typography variant='body2' color='primary' className='uppercase text-xs font-bold'>
                        Learning continua
                      </Typography>
                      {feedback?.lc?.[feedback?.lc?.length - 1] ? (
                        <Typography variant='body2' color='textPrimary' className=' '>
                          {feedback?.lc?.[feedback?.lc?.length - 1]?.name || 'N/A'}
                        </Typography>
                      ) : (
                        <Typography variant='body2' color='textPrimary' className=' '>
                          N/A
                        </Typography>
                      )}
                    </Box>
                  )}
                  {feedback?.level && (
                    <Box className='flex items-center justify-start gap-1'>
                      <Typography variant='body2' color='primary' className='uppercase text-xs font-bold'>
                        level
                      </Typography>
                      <Typography variant='body2' color='textPrimary' className=' '>
                        {feedback?.level || 'N/A'}
                      </Typography>
                    </Box>
                  )}
                  {feedback?.comment && (
                    <Box className='h-14 overflow-hidden '>
                      <Typography variant='body2' color='primary' className='uppercase text-xs font-bold'>
                        comment
                      </Typography>
                      <ReadOnlyTextEditor content={feedback?.comment || ''} />
                    </Box>
                  )}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </CardChart>
  )
}

export default RecentFeedback
